import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";

import PreLoader from "./Loader";
import CoreFeature from "./Features/CoreFeature";
export default function HomePage() {
   useEffect(() => {
      window.scrollTo(0, 0);
      const modal = document.getElementById("DemoVideo");
      const container = document.getElementById("videoContainer");

      const handleShow = () => {
         const iframe = document.createElement("iframe");
         iframe.width = "100%";
         iframe.height = "400";
         iframe.src =
            "https://www.youtube.com/embed/5m5xf4e-GRg?autoplay=1&rel=0&loop=0&html5=1";
         iframe.title = "YouTube video player";
         iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
         iframe.allowFullscreen = true;
         iframe.frameBorder = "0";
         iframe.referrerPolicy = "strict-origin-when-cross-origin";

         container.appendChild(iframe);
      };

      const handleHide = () => {
         container.innerHTML = ""; // remove iframe
      };

      modal?.addEventListener("shown.bs.modal", handleShow);
      modal?.addEventListener("hidden.bs.modal", handleHide);

      return () => {
         modal?.removeEventListener("shown.bs.modal", handleShow);
         modal?.removeEventListener("hidden.bs.modal", handleHide);
      };
   }, []);

    useEffect(() => {
      window.scrollTo(0, 0);
      const modal = document.getElementById("DemoVideos");
      const container = document.getElementById("videoContainers");

      const handleShow = () => {
         const iframe = document.createElement("iframe");
         iframe.width = "100%";
         iframe.height = "600";
         iframe.src = "https://www.youtube.com/embed/Aai2fQ8_hJI?autoplay=1&vq=hd1080&rel=0&loop=0&playsinline=1";
         iframe.title = "YouTube video player";
         iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
         iframe.allowFullscreen = true;
         iframe.frameBorder = "0";
         iframe.referrerPolicy = "strict-origin-when-cross-origin";

         container.appendChild(iframe);
      };

      const handleHide = () => {
         container.innerHTML = ""; // remove iframe
      };

      modal?.addEventListener("shown.bs.modal", handleShow);
      modal?.addEventListener("hidden.bs.modal", handleHide);

      return () => {
         modal?.removeEventListener("shown.bs.modal", handleShow);
         modal?.removeEventListener("hidden.bs.modal", handleHide);
      };
   }, []);

   return (
      <>
         <Helmet>
            <title>
               TaskFlier | Project Management Software for High-Performing Teams
            </title>
         </Helmet>
         <div>
            <PreLoader />
            <div class="hero-banner-one">
               <div class="hero-upper-container">
                  <div class="elementor-widget-container">
						<img  src="https://wdtsassy.wpengine.com/wp-content/uploads/2025/04/slider3-1.jpg" class="glosyimage glosyimage1" alt="slider3-1"loading="eager"/>																								</div>
                  <div class="icon-box-one"> <img src="/main/images/logo/01.png" loading="lazy" alt="chat" /> </div>
                  {/* <div class="icon-box-two"> <img src="/main/images/logo/02.png" loading="lazy" alt="file" /> </div> */}
                  <div class="icon-box-three"> <img src="/main/images/logo/03.png" loading="lazy" alt="chart" /> </div>
                  <div class="icon-box-four"> <img src="/main/images/logo/04.png" loading="lazy" alt="report" /> </div>
                  <div class="icon-box-five"> <img src="/main/images/logo/05.png" loading="lazy" alt="invoice" /> </div>
                  {/* <div class="icon-box-six"> <img src="/main/images/logo/06.png" loading="lazy" alt="Custom" /> </div> */}
                  <div class="icon-box-seven"> <img src="/main/images/logo/07.png" loading="lazy" alt="calender" /> </div>
                  <div class="icon-box-eight"> <img src="/main/images/logo/08.png" loading="lazy" alt="details" /> </div>
                  <div class="bubble-one"></div>
                  <div class="bubble-two"></div>
                  <div class="bubble-three"></div>
                  <div class="bubble-four"></div>
                  <div class="bubble-five"></div>
                  <div class="bubble-six"></div>

                  <div class="elementor-widget-container">
						<img  src="https://wdtsassy.wpengine.com/wp-content/uploads/2025/04/slider3-5.jpg" class="glosyimage glosyimage2" alt="slider3-1"loading="eager"/></div>
                  <div class="container">
                     <div class="row">
                        <div class="col-xl-8 col-lg-10 m-auto">
                           <h1 class="font-rubik hero-heading text-white">One Platform.   <span class="text-white">Complete Business Management.</span></h1>
                           <p class="hero-sub-heading text-white pb-4">
                              customizable, scalable and affordable <strong>project management software</strong>  that helps manage all the core business processes critical for achieving success
                           </p>
                           <div class="d-sm-flex align-items-center justify-content-center button-group">
                              <button type="button" data-bs-toggle="modal" data-bs-target="#request-for-free-trial" class="btn-trial  mt-10 fw-500  font-13 mb-0">
                                 <span>Start your free trial</span> <i class="bi bi-stopwatch font-16"></i></button>


                           </div>
                           <small className="text-white font-11">No credit card required</small>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="herobg"></div>
            </div>
            <div className="fancy-feature-one bgwhite">
               <div className="container">
                  <div class="text-center">
                     <div class="feature-img-area">
                        <div className="row">
                           <div className="col-md-11 m-auto ">
                              <img src="/main/images/video-bg.png" class="dashboard " loading="lazy" alt="Taskflier Dashboard" />
                              <div className="ripple-button">
                                 <div className="button-play" data-bs-toggle="modal" data-bs-target="#DemoVideo"><i class="bi bi-play-fill"></i></div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <section id="feature" className="fancy-feature-six pt-80 mb-100 bgwhite">
               <div class="shapes shape-one"></div>
               <div class="shapes shape-two"></div>
               <div class="shapes shape-three"></div>
               <div class="shapes shape-four"></div>
               <div class="shapes shape-five"></div>
               <img src="images/shape/51.svg" alt="shape" class="shapes shape-six" />
               <div class="container">
                  <div class="title-style-two text-center mb-40 md-mb-40">
                     <h2> Is TaskFlier For You? </h2>
                     <div class="sub-text mt-15 maxsubtitle">
                        Whether you are a start-up, a growing business, or an established enterprise, if you are aiming for a high degree of efficiency in your management processes - TaskFlier is the suite of <strong>project management tool</strong> built just for you.
                     </div>
                     <h3><span class="upper-title custom-name">TaskFlier Currently Available For</span></h3>
                  </div>

                  <div id="carouselExampleCaptions" class="carousel slide">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
   
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="row justify-content-center ">
                     <div class="col-lg-3 col-md-6 col-6 d-flex">
                        <div className="taskflier-available swiperbox">
                          <div className="swiperlist slideA"></div>
                           <div className="tasktitle">
                              <Link to="/solutions/real-estate">
                                 <div className="taskbody">
                                    <h5>Real Estate</h5>
                                    <h6>Read More</h6>
                                 </div>
                              </Link> 
                           </div>
                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div className="taskflier-available swiperbox">

                           <div className="swiperlist slideB"></div>
                           <div className="tasktitle">
                              <Link to="/solutions/chartered-accountant">
                                 <div className="taskbody">
                                    <h5>Chartered Accountant</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>


                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideC"></div>
                           <div className="tasktitle">
                              <Link to="/solutions/software-development">
                                 <div className="taskbody">
                                    <h5>Software Development</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>


                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideD"></div>
                           <div className="tasktitle">
                              <Link to="/solutions/education">
                                 <div className="taskbody">
                                    <h5>Education</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>

                     </div>

                   
                  </div>
    </div>
    <div class="carousel-item">
      <div class="row justify-content-center ">
                   

                     <div class="col-lg-3 col-md-6 col-6 d-flex">

                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideE"></div>
                          
                           <div className="tasktitle">
                              <Link to="/solutions/marketing">
                                 <div className="taskbody">
                                    <h5>Marketing</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>



                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideF"></div>
                        
                           <div className="tasktitle">
                              <Link to="/solutions/startup">
                                 <div className="taskbody">
                                    <h5>Start-up</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>
                     </div>


                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideG"></div>
                          
                           <div className="tasktitle">
                              <Link to="/solutions/hospitality">
                                 <div className="taskbody">
                                    <h5>Hospitality</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available swiperbox">
                           <div className="swiperlist slideH"></div>
                           <div className="tasktitle">
                              <Link to="/solutions/consulting-services">
                                 <div className="taskbody">
                                    <h5>Consulting Services</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>
                        </div>

                     </div>
                  </div>
    </div>
    
  </div>
  <div className="d-flex gap-2 float-end"> 
   <button class="d-flex justify-content-center align-items-center  buttonwhy" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev"><i class="bi bi-arrow-left"></i></button>
  <button class="d-flex justify-content-center align-items-center  buttonwhy" data-bs-target="#carouselExampleCaptions" data-bs-slide="next"><i class="bi bi-arrow-right"></i></button></div>
 
</div>
                  <div class="row justify-content-center pb-100" hidden>
                     <div class="col-lg-3 col-md-6 col-6 d-flex">


                        <div className="taskflier-available">
                           <img src="/main/images/realeatate.webp" loading="lazy" alt="Real Estate" />
                           <div className="tasktitle">
                              <Link to="/solutions/real-estate">
                                 <div className="taskbody content-bg-blur-top ">
                                    <h5>Real Estate</h5>
                                    <h6>Read More</h6>
                                 </div>
                              </Link>
                           </div>
                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div className="taskflier-available">

                           <img src="/main/images/CA.webp" loading="lazy" alt="Chartered Accountant" />
                           <div className="tasktitle">
                              <Link to="/solutions/chartered-accountant">
                                 <div className="taskbody">
                                    <h5>Chartered Accountant</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>


                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available">
                           <img src="/main/images/software.webp" loading="lazy" alt="Software Development" />
                           <div className="tasktitle">
                              <Link to="/solutions/software-development">
                                 <div className="taskbody">
                                    <h5>Software Development</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>


                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available">
                           <img src="/main/images/edu.webp" loading="lazy" alt="Education" />
                           <div className="tasktitle">
                              <Link to="/solutions/education">
                                 <div className="taskbody">
                                    <h5>Education</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>

                     </div>

                     <div class="col-lg-3 col-md-6 col-6 d-flex">

                        <div className="taskflier-available">
                           <img src="/main/images/marketing.webp" loading="lazy" alt="Marketing" />
                           <div className="tasktitle">
                              <Link to="/solutions/marketing">
                                 <div className="taskbody">
                                    <h5>Marketing</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>



                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div className="taskflier-available">
                           <img src="/main/images/start-up.webp" loading="lazy" alt="Start-up" />
                           <div className="tasktitle">
                              <Link to="/solutions/startup">
                                 <div className="taskbody">
                                    <h5>Start-up</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>
                     </div>


                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available">
                           <img src="/main/images/law.webp" loading="lazy" alt="Law" />
                           <div className="tasktitle">
                              <Link to="/solutions/law">
                                 <div className="taskbody">
                                    <h5>Law</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>

                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">

                        <div className="taskflier-available">
                           <img src="/main/images/Consulting-service.webp" loading="lazy" alt="Consulting Services" />
                           <div className="tasktitle">
                              <Link to="/solutions/consulting-services">
                                 <div className="taskbody">
                                    <h5>Consulting Services</h5>
                                    <h6>Read More</h6></div>
                              </Link>
                           </div>

                        </div>

                     </div>
                  </div>
               </div>
            </section>


            <div class="client-feedback-slider-eight lg-container upcoming commingup pt-20 pb-80" id="feedback">
               <div class="container">
                  <div class="main-content position-relative">
                     <div class="row align-items-center justify-content-between">
                        <div class="col-lg-8 col-md-8 m-auto text-center">
                           <div class="feedback-wrapper">
                              <div class="tag bg-primary border-0">Support Coming up soon for…</div>
                              <p class="pr-xl-5 text-center font-22 mb-0 text-dark">TaskFlier is the ultimate platform for any business looking for an adaptable <strong>project management system.</strong> </p>
                           </div>
                        </div>
                     </div>

                     <div class="row">
                        <div class="col-md-12">
                           <div class="item-container">

                              <div class="item"><div><i class="bi bi-bank2"></i> <span>Financial Sector </span> </div>	</div>
                              <div class="item"><div><i class="bi bi-hospital-fill"></i> <span>Healthcare sector	</span> </div></div>
                              <div class="item"><div><i class="bi bi-shop"></i> <span>Retail </span> </div></div>
                              <div class="item"><div><i class="bi bi-building-fill"></i> <span>Manufacturing </span> </div></div>
                              <div class="item"><div><i class="bi bi-bag-check-fill"></i> <span>E-commerce	</span> </div></div>
                              <div class="item"><div><i class="bi bi-house-heart-fill"></i> <span>Hospitality	</span> </div></div>
                              <div class="item"><div><i class="bi bi-luggage-fill"></i> <span>Tour & Travel</span> </div>	</div>
                              <div class="item"><div><i class="bi bi-truck"></i> <span>Logistics & Supply Chain</span> </div></div>
                              <div class="item"><div><i class="bi bi-egg-fried"></i> <span>Agriculture & Food	</span> </div></div>
                              <div class="item"><div><i class="bi bi-buildings"></i> <span>Corporate & Enterprise Services	</span> </div></div>
                              <div class="item"><div><i class="bi bi-shield-fill-check"></i> <span>Administration & Governance </span> </div></div>
                              <div class="item"><div><i class="bi bi-heart-fill"></i> <span>Wellness</span> </div></div>
                              <div class="item"><div><i class="bi bi-bandaid-fill"></i> <span>Insurance</span> </div></div>
                              <div class="item"><div><i class="bi bi-tv-fill"></i> <span>Entertainment</span> </div>	</div>
                              <div class="item"><div><i class="bi bi-camera-reels-fill"></i> <span>Media & Publishing	</span> </div></div>
                              <div class="item"><div><i class="bi bi-controller"></i> <span>Gaming & E-sports</span> </div></div>
                              <div class="item"><div><i class="bi bi-person-standing-dress"></i> <span>Fashion & Apparel	</span> </div></div>
                              <div class="item"><div><i class="bi bi-bounding-box"></i><span>Blockchain & Web3	</span> </div></div>
                              <div class="item"><div><i class="bi bi-house-add-fill"></i> <span>Home Improvement	</span> </div></div>
                              <div class="item"><div><i class="bi bi-brightness-high-fill"></i> <span>Energy & Natural </span> </div></div>
                              <div class="item"><div><i class="bi bi-list-stars"></i> <span>Resources</span> </div></div>




                           </div>
                           <div class="d-sm-flex align-items-center justify-content-center button-group mt-4"><button type="button" data-bs-toggle="modal" data-bs-target="#request-for-free-trial" class="btn-trial  btn-primary mt-10 fw-500  font-13 mb-0"><span>Start your free trial</span> <i class="bi bi-stopwatch font-16"></i></button></div>
                           <div className="text-center"><small class="text-muted text-center font-11">No credit card required</small></div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>


            <div class="fancy-feature-sixteen pt-80 bgwhite" id="feature">
               <div class="container">


                  <div className="row">
                     <div className="col-md-8">
                        <div class="cardfeature cardfeature1 position-relative  align-top mb-35">
                           <img class="glosyimage glosyimage2" style={{bottom:"0"}} alt="slider3-1" loading="eager" src="https://wdtsassy.wpengine.com/wp-content/uploads/2025/04/slider3-5.jpg"/>
                            <div class="text-wrapper">
                              <h6 className="text-muted mb-2">2. Features</h6>
                              <h3 class="maintitle">Project Management</h3>
                              <p className="mainp"> Industries often face missed deadlines, poor communication, and lack of task clarity in their project management. Teams often use disconnected tools, leading to confusion and delays. Tracking progress, managing resources, and ensuring accountability becomes difficult. Without real-time updates and clear workflows, projects easily go off track. These challenges adversely impact productivity, budgets, and client satisfaction.  </p>
                              <p className="mainp">TaskFlier provides a unified project management solution to improve efficiency, collaboration, and results across all types of businesses. It includes project planning software, project tracking software and the entire project management system rolled into one.</p>

                              <ul class="bullet">
                                 <li><strong>Project planning:</strong> Gantt Charts, Milestones, Organogram</li>
                                 <li><strong>Execution:</strong> Task Management, Collaboration</li>
                                 <li><strong>Monitoring:</strong> Real-time Interactive Dashboards, Reports </li>
                              </ul>

                              <Link class="theme-btn-2 mt-10 mb-0" aria-label="Learn more about Project Management" to="/features/task-management-software">
                                 Explore More<i class="bi bi-arrow-right pl-2"></i> </Link>
                           </div></div>
                        <div class="cardfeature cardfeature2 align-top mb-35"><div class="text-wrapper">
                              <h6 className="text-muted mb-2 text-white">2. Features</h6>
                              <h3 class="maintitle text-white" style={{color:"#fff"}}>Task Management</h3>

                              <p className="font-15 mb-2 lineheight-normal text-white" > Managing tasks can get confusing—teams forget deadlines, miss important steps, or don’t know who’s doing what. This often leads to delays and stress.  </p>
                              <p className="font-15 mb-2 lineheight-normal text-white">TakFlier’s <Link to="/features/task-management-software"><strong>task management software</strong></Link> helps by keeping everything in one place. It reminds you of deadlines, shows who’s responsible for what, and helps you stay organized. The task management system  provides clear updates and easy <Link to="/features/time-tracking-software"><strong>tracking</strong></Link>,  make sure that work gets done on time without the usual chaos. </p>

<div className="badge-master gap-2">
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Create & Assign Tasks</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Task Priorities</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Task Status Tracking</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Deadline Management</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Subtasks & Checklists</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Time Tracking</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Task Progress Tracking</span>
<span class="badge badge-pill "><i class="bi bi-circle-fill text-primary font-10 me-1"></i>Task Reports & Analytics</span>
</div>
                           
                              <Link class="theme-btn-2 mt-10 mb-0" to="/features/task-management-software" aria-label="Learn more about Task Management">
                                 Explore More <i class="bi bi-arrow-right pl-2"></i> </Link>
                           </div></div>
                     </div>
                      <div className="col-md-4">
                       <div class="cardfeature cardfeature3 align-top mb-35"> 
                        <div class="text-wrapper">
                              <h6 className="text-muted mb-2">1. Features</h6>
                              <h3 class="maintitle">HR Management</h3>
                                <p className="mainp">Complete HR Management, From Employee Onboarding to Payroll.</p>

                             
                             <div className="badge-master-hrms gap-2">
                              
<span class="badge badge-pill badge-info">Atendance</span>
<span class="badge badge-pill badge-secondary">Recruitment</span>
<span class="badge badge-pill badge-success">Shift & Overtime</span>
<span class="badge badge-pill badge-primary">Employee Management</span>
<span class="badge badge-pill badge-danger">Leave Management</span>
<span class="badge badge-pill badge-warning">Mobile HRMS Access</span>
<span class="badge badge-pill badge-danger">Document Management</span>
<span class="badge badge-pill badge-warning mb-0">Reports & Analytics</span>
<span class="badge badge-pill badge-warning mb-0 mr-0">Department & Designation</span>

</div>
                           
                           </div> </div>
                       <div class="cardfeature cardfeature4 align-top mb-35">
                         <div class="text-wrapper">
                              <h6 className="text-muted mb-2">1. Features</h6>
                              <h3 class="maintitle">Payroll Management</h3>
                                <p className="mainp">Automate Salary Processing, Deductions, Payslips & Payroll Reports.</p>

                             
                             <ul class="list-group payroll">
  <li class="list-group-item d-flex justify-content-between align-items-center">
      Automated Salary Calculation
    <span class="badge badge-primary badge-pill">14</span>
  </li>

  <li class="list-group-item d-flex justify-content-between align-items-center">
    Payroll Processing
    <span class="badge badge-primary badge-pill">1</span>
  </li>

  <li class="list-group-item d-flex justify-content-between align-items-center">
      Payslip Generation
    <span class="badge badge-primary badge-pill">14</span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center">
   Bulk Payroll Processing
    <span class="badge badge-primary badge-pill">2</span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center">
    Salary History
    <span class="badge badge-primary badge-pill">1</span>
  </li>


  <li class="list-group-item d-flex justify-content-between align-items-center">
   Payroll Reports
    <span class="badge badge-primary badge-pill">2</span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center mb-0">
    Payroll Compliance Reports
    <span class="badge badge-primary badge-pill">1</span>
  </li>

  
</ul>

                              
                           </div>
                       </div>
                      </div>
                  </div>
                 
               
                  <div class="title-style-twelve mt-80 pt-50 md-mt-80">
                     <div class="row align-items-center">
                        <div class="col-lg-5 ">
                           <div class="text-wrapper">
                              <h6 className="text-muted mb-2">3. Features</h6>
                              <h3 class="maintitle">Customer Relationship Management</h3>
                              <ul class="bullet">
                                 <li><strong>Core CRM:</strong>	Contact database, Lead management</li>
                                 <li><strong>Communication:</strong> Email Sync, Notes, History</li>
                                 <li><strong>Viewing & Reporting:</strong> Dashboards, Conversion, Client Value</li>
                                 <li><strong>Integration:</strong> Calendar, Email, Payments, Helpdesk</li>
                              </ul>
                              <Link class="theme-btn-2 mt-10 md-mt-30" to="/features/client-management-software" aria-label="Learn more about Customer Relationship Management">
                                 Explore More <i class="bi bi-arrow-right pl-2"></i> </Link>
                           </div>
                        </div>
                        <div class="col-lg-6 offset-lg-1">
                           <div class="screen-holder-two "> <img src="/main/images/clients.jpg" loading="lazy" alt="Clients Management" /> </div>
                        </div>
                     </div>
                  </div>
                  <div class="title-style-twelve mt-80 pt-50 md-mt-80">
                     <div class="row align-items-center">
                        <div class="col-lg-5 offset-lg-1 order-lg-last ">
                           <div class="text-wrapper">
                              <h6 className="text-muted mb-2">4. Features</h6>
                              <h3 class="maintitle">Ticket Management</h3>
                              <ul class="bullet">

                                 <li><strong>Ticket handling:</strong>  Create, Assign, Prioritize, Tag, Merge</li>
                                 <li><strong>Communication:</strong> Multichannel, Notes, Templates, Portal</li>
                                 <li><strong>Workflow:</strong> SLAs, Automation, Status, Escalation</li>
                                 <li><strong>Viewing & Reporting:</strong> Interactive </li>

                              </ul>
                              <Link class="theme-btn-2 mt-10 mb-20" to="/features/task-management-software" aria-label="Learn more about Ticket Management">
                                 Explore More <i class="bi bi-arrow-right pl-2"></i> </Link>
                           </div>
                        </div>
                        <div class="col-lg-6 order-lg-first">
                           <div class="screen-holder-two"> <img src="/main/images/ticket.jpg" loading="lazy" alt="Ticket management" /> </div>
                        </div>
                     </div>
                  </div>

                 



                

               </div>
            </div>

            <div id="resources" class="fancy-feature-fortySix lg-container pt-80 pb-80 ">
               <div class="container position-relative">

                  <div class="title-style-two text-center mb-40 md-mb-40"><h2>TaskFlier: Additional Features </h2>
                  </div>

                  <div class="row justify-content-center">
                     <div class="col-lg-4 col-md-6">
                        <div class="choose-right-wrapper">


                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-ui-checks-grid"></i></div>
                              <div class="content">
                                 <h4>Access control</h4>
                                 <p className="mainp">User Roles & Permissions</p>
                              </div>
                           </div>
                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-database-lock"></i></div>
                              <div class="content">
                                 <h4>Data privacy</h4>
                                 <p className="mainp">GDPR and DPDPA compliance</p>
                              </div>
                           </div>

                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-menu-down"></i></div>
                              <div class="content">
                                 <h4>User Interface & Usability </h4>
                                 <p className="mainp">Intuitive, clean UI, Drag-and-drop interactivity, Multilingual support</p>
                              </div>
                           </div>


                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-display"></i></div>
                              <div class="content">
                                 <h4>Cross-Platform Access</h4>
                                 <p className="mainp">Web, mobile (iOS/Android)</p>
                              </div>
                           </div>

                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-filetype-csv"></i></div>
                              <div class="content">
                                 <h4>Import/Export Options</h4>
                                 <p className="mainp">CSV or Excel import/export</p>
                              </div>
                           </div>


                        </div>
                     </div>
                     <div class="col-lg-4 col-md-6">
                        <div className="why"> <img src="/main/images/why-choose.jpg" loading="lazy" alt="why-choose" /></div>
                     </div>
                     <div class="col-lg-4 col-md-6">
                        <div class="choose-right-wrapper">

                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-shield-check"></i></div>
                              <div class="content">
                                 <h4>Data security</h4>
                                 <p>AES and SSL encryption, Data backups and recovery</p>
                              </div>
                           </div>
                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-code-slash"></i></div>
                              <div class="content">
                                 <h4>Integration & Extensibility </h4>
                                 <p className="mainp">Third-Party Integration, API Access</p>
                              </div>
                           </div>

                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-file-earmark-bar-graph"></i></div>
                              <div class="content">
                                 <h4>Document management</h4>
                                 <p className="mainp">Store and manage attached files, images, or documents</p>
                              </div>
                           </div>
                           <div class="featured-box mb-35">
                              <div class="icon"><i class="bi bi-headset"></i></div>
                              <div class="content">
                                 <h4>Help & Support </h4>
                                 <p className="mainp">24x7 support and issue resolution</p>
                              </div>
                           </div>
                           <div class="featured-box">
                              <div class="icon"><i class="bi bi-clock-history"></i></div>
                              <div class="content">
                                 <h4>Time Tracking</h4>
                                 <p className="mainp">Log time spent on each task, employee tracking</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

               </div>
            </div>

            <div id="feature" className="fancy-feature-six pt-80 bp-100 bgwhite">
               <div class="shapes shape-one"></div>
               <div class="shapes shape-two"></div>
               <div class="shapes shape-three"></div>
               <div class="shapes shape-four"></div>
               <div class="shapes shape-five"></div>
               <img src="images/shape/51.svg" alt="shape" class="shapes shape-six" />
               <div class="container">
                  <div class="title-style-two text-center mb-40 md-mb-40">
                     <h2> TaskFlier: 4-Step Super-easy Deployment </h2>

                  </div>
                  <div class="row justify-content-center pb-100">
                     <div class="col-lg-3 col-md-6 col-6 d-flex">
                        <div class="block-style-choose">
                           <div class="icon"> <img src="/main/images/document.png" loading="lazy" alt="step-1" /> <span className="count-why "> <span className="red">01</span> </span> </div>
                           <h6 class="why-title"> <span>Fill Details & Create an Account</span> </h6>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div class="block-style-choose active">
                           <div class="icon"> <img src="/main/images/consulting.png" loading="lazy" alt="step-2" /> <span className="count-why"> <span className="blue">02</span> </span> </div>
                           <h6 class="why-title"> <span>Update Your Company Details</span> </h6>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div class="block-style-choose">
                           <div class="icon"> <img src="/main/images/process.png" loading="lazy" alt="step-3" /> <span className="count-why"> <span className="green">03</span> </span> </div>
                           <h6 class="why-title"> <span>Add Client, Project, Or Team</span> </h6>
                        </div>
                     </div>
                     <div class="col-lg-3 col-md-6 col-6 d-flex ">
                        <div class="block-style-choose">
                           <div class="icon"> <img src="/main/images/checking.png" loading="lazy" alt="step-4" /> <span className="count-why"> <span className="yellow">04</span> </span> </div>
                           <h6 class="why-title"> <span>Start Your Projects & Maintain Progress</span> </h6>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

	<div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
					<div class="container">
						<div class="title-style-two text-center mb-40 md-mb-40">
							<h6><span class="upper-title custom-name">Security & Compliance</span></h6>

                     <h3 class="maintitle mt-2"><span>Your Data, Our Top Priority</span></h3>


							<div class="sub-text mt-0 pt-3 maxsubtitle">At Taskflier, your data security is our top priority. With enterprise-grade encryption, strict access controls, and compliance with industry standards, we ensure your information is safe. Our continuously updated security measures give you complete confidence in data protection.
							</div>
						</div>

						<div class="row  features">


							<div class="col-lg-3 col-12 ">

								<div class="Solutions-box p-0 py-3 secure-certification" >
                          
									<img src="/images/SOC.png" alt="Task creation" class="w-100 certification" />
                           <div class="highlighttext mt-2 mb-3">
                        <div class="text">SOC 2 Type II</div>
                    </div>
								
									<p className="mainp certificationp px-4">Our SOC 2 Type II attestation reflects a strong commitment to maintaining the highest standards of security, privacy, availability, processing integrity, and confidentiality.</p>
								</div>

							</div>
							<div class="col-lg-3 col-12 ">

								<div class="Solutions-box p-0 py-3 secure-certification" >
									<img src="/images/GDPR.png" alt="Customizing taskboard" class="w-100 certification" />
								
                           <div class="highlighttext mt-2 mb-3">
                        <div class="text">GDPR Compliance</div>
                    </div>
									
									<p className="mainp certificationp px-4">As a GDPR-compliant organization, we strictly follow regulations governing the collection, storage, and processing of personal information, ensuring complete transparency and protection.</p>

								</div>

							</div>
							<div class="col-lg-3 col-12 ">

								<div class="Solutions-box p-0 py-3 secure-certification" >
									<img src="/images/ISO.png" alt="Task dependencies" class="w-100 certification" />
								
                           <div class="highlighttext mt-2 mb-3">
                        <div class="text">ISO 27001 Certification</div>
                    </div>
									
									<p className="mainp certificationp px-4">Holding ISO 27001 certification demonstrates our compliance with globally recognized standards for information security management systems (ISMS).</p>


								</div>
							</div>

							<div class="col-lg-3 col-12 ">

								<div class="Solutions-box p-0 py-3 secure-certification" >
									<img src="/images/HIPPA.png" alt="Task creation" class="w-100 certification" />
								
                           <div class="highlighttext mt-2 mb-3">
                        <div class="text">HIPAA Compliance</div>
                    </div>
                    
								
									<p className="mainp certificationp px-4">We adhere to the rigorous requirements of HIPAA, ensuring the confidentiality and security of sensitive health-related information.</p>


								</div>

							</div>
						
						</div>

                    <div className="mega-secure">
                     <div class="row">
              <div className="col-md-12">
                <div class="item-container">

                  <div class="item"><img src="images\certificate/badge-04.webp" loading="lazy" alt="ISO Certified" /></div>
                  <div class="item"> <img src="images\certificate/badge-08.webp" loading="lazy" alt="ISO Certified" /></div>
                  <div class="item"> <img src="images\certificate/badge-07.webp" loading="lazy" alt="ISO Certified" /></div>
                  <div class="item"><Link target="_blank" to="https://www.topdevelopers.co/companies/software-development" aria-label="Visit Taskflier Profile">
                                    <img src="https://www.topdevelopers.co/assets/badges/app-2024/Software-Development/badge-top-software-developers-2024.png" loading="lazy" alt="Top Software Developer" title="Top Software Developer" /> </Link></div>
                  
                  
                  <div class="item"><Link target="_blank" to="https://www.goodfirms.co/project-management-software/" aria-label="Visit Taskflier Profile">
                                    <img src="images\certificate/badge-02.png" title="Top Project Management Software" loading="lazy" alt="Top Project Management Software" /> </Link></div>
                 
                  <div class="item"><Link to='https://www.designrush.com/agency/profile/task-flier' target='_blank' aria-label="Visit Taskflier Profile">
                                    <img src="images\certificate/Verified.webp" alt="Verified Certificate" loading="lazy" /> </Link></div>
                 
                  <div class="item"><Link to='https://www.techimply.com/profile/taskflier' target='_blank' aria-label="Visit Taskflier Profile">
                                    <img src="images\certificate/badge-01.webp" alt="Top Project Management Software" loading="lazy" /> </Link></div>
                  

                  <div class="item">
                     <Link to='https://www.softwaresuggest.com/taskflier' target='_blank' aria-label="Visit Taskflier Profile">
                                    <img src="https://www.softwaresuggest.com/award_logo/customer-choice-winter-2025.png" loading="lazy" alt="Customer Choice 2025" /> </Link></div>
                 
                  <div class="item"> <Link to='https://www.softwaresuggest.com/taskflier' target='_blank' aria-label="Visit Taskflier Profile">
                                    <img src="https://www.softwaresuggest.com/award_logo/highly-recommended-winter-2025.png" loading="lazy" alt="Highly Recommended 2025" /> </Link></div>
                 

                </div>


                <div class="d-sm-flex align-items-center justify-content-center button-group mt-4">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#request-for-free-trial" class="btn-trial  btn-primary mt-10 fw-500  font-13 mb-0">


                    <span>Start your free trial</span> <i class="bi bi-stopwatch font-16"></i>


                  </button>


                </div>
                <div className="text-center pt-0 "><small className="text-primary text-center font-11">No credit card required</small></div>
              </div>

            </div>
                    </div>
					</div>
				</div>


            <div class="fancy-feature-ten pt-100 bg-white" id="feature">
               <div class="bg-wrapper pt-80">
                  <div class="container">
                     <div class="title-style-two text-center mb-40 md-mb-40">
                        <h2>Why TaskFlier?</h2>

                     </div>




                     <div class="row  features">


                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                              <img src="/main/images/why1.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              <div class="pack-name">Functionality</div>
                              <p className="mainp">Comprehensive coverage of functionalities that an ideal business management software tool is expected to have</p>
                           </div>

                        </div>
                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                              <img src="/main/images/why2.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              <div class="pack-name">Flexibility</div>
                            
                              <p className="mainp">Highly customizable and configurable to suit the unique needs of every business</p>



                           </div>

                        </div>
                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why3.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              
                              <div class="pack-name">Cost and Value for money</div>
                             

                              <p className="mainp">Available at arguably the most competitive price compared to similar software tools available in the market  </p>


                           </div>

                        </div>
                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why4.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              
                              <div class="pack-name">Scalability
                              </div>

                              
                              <p className="mainp">
                                 Capable of handling growth in number of users, data, and transactions without performance degradation
                              </p>
                           </div>

                        </div>
                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why1.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              
                              <div class="pack-name">Support & Customer Service</div>

                             
                              <p className="mainp">24/7 support available via live chat, phone, or email and quick resolution</p>
                           </div>
                        </div>

                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why2.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              
                              <div class="pack-name">Performance & Reliability</div>

                              
                              <p className="mainp">Guaranteed uptime with fast and responsive under varied loads</p>
                           </div>
                        </div>


                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why3.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              <div class="pack-name">Integration & Compatibility</div>

                              
                              <p className="mainp">Capability of third-party integrations with most of the software tools through APIs and webhooks</p>
                           </div>
                        </div>


                        <div class="col-lg-3 col-12 ">

                           <div class="Solutions-box border-0 " >
                              <img class="dotedimage" src="/main/images/shapes.png" alt=""/>
                               <img src="/main/images/why4.webp" alt="Task creation" class="w-80"  style={{ maxWidth: '160px', margin: '0 auto', marginBottom: '20px' }} />
                              <div class="pack-name">Innovation & Updates</div>
                              <p className="mainp">Regular updates, improvements and adoption to new technologies such as AI made available as and when needed</p>
                           </div>
                        </div>

                        <div class="d-sm-flex align-items-center justify-content-center button-group mt-4">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#DemoVideos" class="btn-trial  btn-primary mt-10 fw-500  font-13 mb-0">


                    <span>Why Choose TaskFlier </span> <i class="bi bi-play-fill font-16"></i>


                  </button>


                </div>
                     </div>


                  </div>
                  <img src="/images/shape/137.svg" alt="shape" loading="lazy" class="shapes shape-one" />
               </div>
            </div>

            <div className="partner-slider-two pb-80 pt-80 bgwhite">
               <div className="container">
                  <p className="text-center"> <span>50+</span> Users of TaskFlier Project Management are happy with its advanced features </p>
                  <div className="partnerSliderTwo slick-initialized slick-slider">
                     <div className="slick-list d-flex draggable align-items-center justify-content-center" >

                        <div className="slick-track d-flex" > <div className="item slick-slide slick-current slick-center" aria-hidden="true" >
                           <div className="img-meta d-flex align-items-center justify-content-center"> <img src="/main/images/client/03.png" loading="lazy" alt="client 1" /> </div>
                        </div>
                           <div className="item slick-slide" aria-hidden="true" >
                              <div className="img-meta d-flex align-items-center justify-content-center"> <img src="/main/images/client/04.png" loading="lazy" alt="client 2" /> </div>
                           </div>
                           <div className="item slick-slide" aria-hidden="true" >
                              <div className="img-meta d-flex align-items-center justify-content-center"> <img src="/main/images/client/05.png" loading="lazy" alt="client 3" /> </div>
                           </div>
                           <div className="item slick-slide" aria-hidden="true" >
                              <div className="img-meta d-flex align-items-center justify-content-center"> <img src="/main/images/client/06.png" loading="lazy" alt="client 4" /> </div>
                           </div> <div className="item slick-slide slick-active slick-center" aria-hidden="false" >
                              <div className="img-meta d-flex align-items-center justify-content-center"> <img src="/main/images/client/07.png" loading="lazy" alt="client 4" /> </div>
                           </div> </div> </div> </div> </div> </div>


            <CoreFeature />

          


            <div className="faq-classic pt-0 bg-white">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="title-style-one mb-40">
                           <h6 className="font-rubik">Find your answers</h6>
                           <h2>Have any thought? Look here.</h2>
                        </div>
                     </div>
                     <div className="col-lg-12">
                        <div id="accordion" className="md-mt-60">
                           <div className="card">
                              <div className="card-header" id="headingOne">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> What is the use of the TaskFlier Project Management System? </button> </h5>
                              </div>
                              <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> TaskFlier project management system is an effective tool that helps organizations manage their projects, resources, and teams and makes it possible for them to meet their short-term and long-term objectives.{" "} </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingTwo">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo"> How to Project Management System Benefit Remote Teams?{" "} </button> </h5>
                              </div>
                              <div id="collapseTwo" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> TaskFlier project management system comes with a centralized platform for easy communication and management processes. By making these processes easy, it helps organizations to achieve their goals with a remote team.{" "} </p>
                                 </div>
                              </div>
                           </div>


                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree"> Can we customize the project management system? </button> </h5>
                              </div>
                              <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> When it comes to project needs, each business organization has different needs and requirements. So, TaskFlier allows its clients to customize its project management system according to their business needs.{" "} </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingFour">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour"> Can we check the real-time availability of our employees using the project management system? </button> </h5>
                              </div>
                              <div id="collapseFour" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> Yes, the TaskFlier project management system comes with the best features that allow you to check the real-time availability of your employees.{" "} </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingFive">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive"> Can we store our employee's and client's data using a project management system? </button> </h5>
                              </div>
                              <div id="collapseFive" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> Yes, with the help of a project management system, you can store your employee’s and client’s data.{" "} </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingFive2">
                                 <h5 className="mb-0"> <button className="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseFive2" aria-expanded="true" aria-controls="collapseFive2"> Can we reschedule the project deadlines in a project management system? </button> </h5>
                              </div>
                              <div id="collapseFive2" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                 <div className="card-body">
                                    <p> Yes, you can reschedule the project deadlines in a project management system.{" "} </p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>


            <div className="modal fade zoom modal-contact-popup-one" id="DemoVideo" tabIndex={-1} role="dialog" data-bs-backdrop="static" aria-labelledby="contactModalTitle" aria-hidden="true">
               <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                  <main className="main-body modal-content clearfix">

                     {/* <div className="headpopup">
                        <p className="form-pre">Safe &amp; Confidential</p>
                        <h2 className="form-title">Request For Free 7-Day Trial</h2>
                    </div> */}


                     <div className="right-side p-0">
                        <button type="button" className="close btnmodl" data-bs-dismiss="modal" aria-bs-label="close" >
                           <img src="/main/images/icon/close.svg" alt="modal-close" />
                        </button>
                        <div id="videoContainer"></div>
                     </div>

                  </main>
               </div>
            </div>

            
<div class="modal fade zoom modal-contact-popup-one" id="DemoVideos" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
    
      <div class=" main-body modal-body  p-0 rounded"  style={{lineHeight:"0", overflow:"hidden"}} data-bs-dismiss="modal" >
		

  <div className="right-side p-0">
                        <button type="button" className="close btnmodl" data-bs-dismiss="modal" aria-bs-label="close" >
                           <img src="/main/images/icon/close.svg" alt="modal-close" />
                        </button>
                        <div id="videoContainers"></div>
                     </div>
	  
      </div>
     
    </div>
  </div>
</div>
         </div>
      </>
   );
}
